// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zRed":"rgb(237, 85, 100)","toastContainer":"_2U74","toast":"_1Mbd","toastInner":"_1uuI","close":"_3Zr2","error":"_5AfS","enter":"CNtb","appear":"_2hJA","enterActive":"_23xn","appearActive":"_1JuG","exit":"_3PY-","exitActive":"_32IM"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Toasts/Toasts.scss
// module id = YOwp
// module chunks = 0